import {Component, OnDestroy, OnInit} from '@angular/core';
import {TabOrderStatus} from '../../../core/models/order.model';
import {Subject} from 'rxjs';
import {Router} from '@angular/router';
import {PopoverController} from '@ionic/angular';
import {PaymentStore} from '../../../core/stores/payment.store';
import {Customer} from '../../../core/models/customer.model';
import {CartStore} from '../../../core/stores/cart.store';
import {RouteService} from '../../../core/services/route.service';

@Component({
  selector: 'app-tab-orders-status',
  templateUrl: './tab-orders-status.component.html',
  styleUrls: ['./tab-orders-status.component.scss']
})
export class TabOrdersStatusComponent implements OnInit, OnDestroy {
  public tabOrdersStatus: TabOrderStatus[] = [];
  public customer: Customer;
  private destroyed$ = new Subject<void>();

  public get isGroup(): boolean {
    return !!this.cartStore.groupTab;
  }

  constructor(
    public cartStore: CartStore,
    public paymentStore: PaymentStore,
    private router: Router,
    private routeService: RouteService,
    private popoverController: PopoverController
  ) {
  }

  public ngOnInit(): void {
    this.customer = this.paymentStore.customer;
    let orderCounter = 1;
    if (this.cartStore.tab) {
      for (const order of this.cartStore.tab.square_orders) {
        this.tabOrdersStatus.push(new TabOrderStatus(order.id, orderCounter.toString(), order.customer_id, order.line_items));
        orderCounter++;
      }
    } else {
      for (const round of this.cartStore.groupTab.rounds) {
        const {group_order_id, customer_id} = this.cartStore.groupTab;
        let roundOrderLineItems: any[][] = [];
        for (const order of round.round_orders) {
          roundOrderLineItems = [...roundOrderLineItems, order.line_items];
        }
        // @ts-ignore
        this.tabOrdersStatus.push(new TabOrderStatus(group_order_id, orderCounter.toString(), customer_id, roundOrderLineItems.flat()));
        orderCounter++;
      }
    }
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
  }

  public goToCloseTabPage() {
    const url = this.isGroup ? this.routeService.getGroupUrl() : this.routeService.getLocationUrl();
    this.router.navigate([url, 'close-tab'])
      .catch(error => console.error(error));
    this.popoverController.dismiss();
  }

  public close() {
    this.popoverController.dismiss();
  }
}
